module.exports = __webpack_public_path__ + "img/Group_6.e9f44ba6.png";